import React, {useState, useEffect, useRef} from "react"
import styles from "../../../Pages/Corpus/corpus.module.css"
import BaseInfoStyles from "./BaseInformation.module.css"
import percentsStyles from "../../../Pages/BaseList/BaseList.module.css"
import VictimListStyles from "../../../Components/VictimsList/VictimsList.module.css"
import { faFloppyDisk, faPenToSquare, faPlus, faTrash } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { axiosInstance } from "../../../Helpers/axiosInstance";
import PeopleInformation from "./PeopleInformation";

const BaseInformation = ({array, setArray, radio, setRadio, submitHandler, unit}) => {

    const [addInf, setAddInf] = useState(false)
    const [weapons, setWeapons] = useState([])
    const [obj, setObj] = useState({
        rang: '',
        special_radio: '2.1',
        full_name: '',
        conscription: '',
        subvision: '',
        position: '',
        gun_type: '',
        gun_number: '',
        other_information: '',
    })

    const [disabled, setDisabled] = useState(true)
    const [change, setChange] = useState(null)
    const [changeIndex, setChangeIndex] = useState(null)
    
    
    useEffect(() => {
            if(obj.full_name) {
                setDisabled(false)
            } else {
                setDisabled(true)
            }
    }, [obj.full_name])

    useEffect(() => {
            (async() => {
                const weapons = await axiosInstance.get('admin/weapons')
                if(weapons.status){
                    setWeapons(weapons.data.data)
                }
            })()
    }, [])
    
    const fillArrayHandler = (object) => {
        setArray((prevArray) => [...prevArray, object])
        setObj({
            rang: '',
            special_radio: '',           
            full_name: '',
            conscription: '',
            subvision: '',
            position: '',
            gun_type: '',
            gun_number: '',
            other_information: '',
        })
        setAddInf(false)
    }
   
    function changePerson(el, index) {
        setChange(el)
        setObj({ ...el })
        setChangeIndex(index)
    }

    function changeHandler(event) {
        const {name, value} = event.target
        setObj({
            ...obj,
            [name]: value
        })
    }

    function changeArrayHandler() {
        setChange(null)
        setArray(() => {
            const newArray = [...array]
            newArray[changeIndex] = {...change, ...obj}
            setChangeIndex(null)
            return newArray
        })
        
        setObj({
            rang: '',
            special_radio: '',           
            full_name: '',
            conscription: '',
            subvision: '',
            position: '',
            gun_type: '',
            gun_number: '',
            other_information: '',
        })
        
    }

    const deleteHandler = (index) => {
        const confirmation = window.confirm("Հաստատո՞ւմ եք, որ ցանկանում եք հեռացնել տվյալները")
        if(!confirmation) return
        setArray(() => {
            const newArray = [...array]
            newArray.splice(index, 1)
            return newArray
        })
    }

    const openAdding = () => {
        setObj({
            rang: '',
            special_radio: '2.1',           
            full_name: '',
            conscription: '',
            subvision: '',
            position: '',
            gun_type: '',
            gun_number: '',
            other_information: '',
        })
        setChange(null)
        setChangeIndex(null)
        setAddInf(true)
    }

    
    return (
        <div className={BaseInfoStyles["hole-base-info"]}>

            <div className={`${styles["corpus-main-div"]} ${VictimListStyles['main-div']}`} style={{height: "fit-content"}}>
                <FontAwesomeIcon icon={faPlus} className={BaseInfoStyles['adding']} title="Ավելացնել տվյալներ" onClick={openAdding}/>
                <div className={`${styles["corpus-container"]}`}>
                    <div className={styles["header2"]}>Անձնակազմի տվյալները </div>
                </div>
                <div className={styles["corpus-list"]} >
                    <ol>
                        <li className={styles["corpus-list-item"]}>
                            <p className={percentsStyles["per5"]}>Կոչում</p>
                            <p className={percentsStyles["per5"]}>Զ/կոչ</p>
                            <p className={percentsStyles["per10"]}>Անուն Ազգանուն Հայրանուն</p>
                            <p className={percentsStyles["per10"]}>Ստորաբաժանում</p>
                            <p className={percentsStyles["per15"]}>Պաշտոնը</p>
                            <p className={percentsStyles["per10"]}>Զենքի տեսակը</p>
                            <p className={percentsStyles["per10"]}>Զենքի համարը</p>
                            <p className={percentsStyles["per10"]}>Առանձնահատուկ</p>
                            <p className={percentsStyles["per10"]}>Այլ տվյալներ</p>
                            <p className={percentsStyles["per10"]}>Ղեկավարման կոճակներ</p>
                        </li>
                        {!!array.length && array.map((el, index) => {
                            return <li key={index} className={`${styles["corpus-list-item"]} ${changeIndex === index ? BaseInfoStyles["selected-line"] : ""}`}>
                                    <textarea disabled={changeIndex !== index} type="text" name="rang"  value={changeIndex !== index ? el?.rang : obj.rang} onChange={changeHandler} className={`${percentsStyles["per5"]} ${BaseInfoStyles['list-input']}`} />
                                    <textarea disabled={changeIndex !== index} type="text" name="conscription" value={changeIndex !== index ? el?.conscription : obj.conscription} onChange={changeHandler} className={`${percentsStyles["per5"]} ${BaseInfoStyles['list-input']}`}/>
                                    <textarea disabled={changeIndex !== index} type="text" name="full_name" value={changeIndex !== index ? el?.full_name : obj.full_name} onChange={changeHandler} className={`${percentsStyles["per10"]} ${BaseInfoStyles['list-input']}`}/>
                                    <textarea disabled={changeIndex !== index} type="text" name="subvision" value={changeIndex !== index ? el?.subvision : obj.subvision} onChange={changeHandler} className={`${percentsStyles["per10"]} ${BaseInfoStyles['list-input']}`}/>
                                    <textarea disabled={changeIndex !== index} type="text" name="position" value={changeIndex !== index ? el?.position : obj.position} onChange={changeHandler} className={`${percentsStyles["per15"]} ${BaseInfoStyles['list-input']}`}/>
                                    <textarea disabled={changeIndex !== index} type="text" name="gun_type" value={changeIndex !== index ? el?.gun_type : obj.gun_type} onChange={changeHandler} className={`${percentsStyles["per10"]} ${BaseInfoStyles['list-input']}`}/>
                                    <textarea disabled={changeIndex !== index} type="text" name="gun_number" value={changeIndex !== index ? el?.gun_number : obj.gun_number} onChange={changeHandler} className={`${percentsStyles["per10"]} ${BaseInfoStyles['list-input']}`}/>
                                    {changeIndex !== index ? <textarea disabled={changeIndex !== index} type="text" name="special_radio" value={changeIndex !== index ? el?.special_radio : obj.special_radio} className={`${percentsStyles["per10"]} ${BaseInfoStyles['list-input']}`}/> : 
                                    <select disabled={changeIndex !== index} type="text" name="special_radio" value={changeIndex !== index ? el?.special_radio : obj.special_radio} onChange={changeHandler} className={`${percentsStyles["per10"]} ${BaseInfoStyles['list-input']}`}>
                                        <option value="2.1">2.1 Կետ</option>
                                        <option value="2.2">2.2 Կետ</option>    
                                        <option value="3.1">3.1 Կետ</option>
                                        <option value="3.2">3.2 Կետ</option>
                                    </select>}
                                    <textarea disabled={changeIndex !== index} type="text" name="other_information" value={changeIndex !== index ? el?.other_information : obj.other_information} onChange={changeHandler} className={`${percentsStyles["per10"]} ${BaseInfoStyles['list-input']}`}/>
                                    <button className={`${percentsStyles["per10"]} btn ${BaseInfoStyles["change-btn"]}`}>
                                        {changeIndex === index ? 
                                        <FontAwesomeIcon icon={faFloppyDisk} title="Պահպանել փոփոխությունը" className={BaseInfoStyles['save']} onClick={changeArrayHandler}/> : 
                                        <FontAwesomeIcon icon={faPenToSquare} title="Փոփոխել" className={BaseInfoStyles['edit']} onClick={() => changePerson(el, index)}/>}
                                        <FontAwesomeIcon icon={faTrash} title="Հեռացնել" className={BaseInfoStyles['delete']} onClick={() => deleteHandler(index)}/>
                                    </button>
                                </li>
                        })}
                        {addInf && <PeopleInformation unitId={unit} onClose={() => setAddInf(false)} fillArrayHandler={fillArrayHandler}/>}
                    </ol>
                </div>
            </div>
           
        </div>
        )
}

export default BaseInformation